export default function getProductStatus({ product }) {
    return !product.check_availability
        ? "future"
        : product.available <= 0
        ? "notAvailable"
        : product.deliveryDate != "" && product.deliveryDate != null
        ? "transit"
        : "available";
}
